<template>
  <div style="display: flex; height: 100%; margin-top: -20px">
    <div class="dy">
      <p class="p-bar">
        <span>额定电压</span>
        <span> 220V </span>
      </p>
      <p class="p-bar">
        <span>额定频率</span>
        <span> 50Hz </span>
      </p>
      <p class="p-bar">
        <span>额定输出容量</span>
        <span> 200VA </span>
      </p>
      <p class="p-bar">
        <span>变压器型号</span>
        <span>NDK-200</span>
      </p>
    </div>
    <div class="tjt">
      <dv-decoration-9 style="width: 150px; height: 150px">
        <div class="circle-text">
          <p>24V</p>
          <p>副边电压</p>
        </div>
      </dv-decoration-9>
      <div class="bottom-div">
        <div class="circle-text">
          <p>最高</p>
          <p>110V</p>
        </div>
        <div class="circle-text">
          <p>最低</p>
          <p>6V</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.dy {
  flex: 1;
  padding: 0 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.tjt {
  flex: 0.5;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.p-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ace6ff;
}

.circle-text {
  text-align: center;
  color: #ace6ff;
}
.circle-text > p {
  margin: 5px 0;
}
.bottom-div {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
